export const modalCloseRequest_v1_schema = {
  type: 'object',
};
